// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__LhW4A","button":"Button_button__71GMN","button_disable":"Button_button_disable__p0TWL"};